import { render, staticRenderFns } from "./BasicCopy.vue?vue&type=template&id=709c9f84&"
import script from "./BasicCopy.vue?vue&type=script&lang=ts&"
export * from "./BasicCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports